import LayoutResource from '@/modules/ta/dashboard/resources/LayoutResource';
import SectionTemplateResource from '@/modules/ta/dashboard/resources/templates/SectionTemplateResource';
import { deepClone, shallowCopyKeyedObject } from '@/modules/core/helper';
import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import { Layout } from '@/modules/ta/dashboard/models/Layout';

export class LayoutService extends BaseService {
  /**
   * @param {Layout[]} layouts
   */
  async saveList(layouts) {
    const saveLayouts = [];
    layouts.forEach((layout) => {
      const newLayout = shallowCopyKeyedObject(layout);
      newLayout.widgets = null;
      saveLayouts.push(newLayout);
    });

    const newLayouts = await LayoutResource.saveList(saveLayouts);
    return newLayouts.map((layout) => new Layout(layout));
  }

  async updateWidgetDisplayOrder(layoutId, model) {
    return LayoutResource.updateWidgetDisplayOrder(layoutId, model);
  }

  /**
   *
   * @param pageId
   * @param displayOrder
   * @param metadata
   * @param title
   * @returns {Promise<*|{}|void>}
   */
  async addNewLayout(pageId, displayOrder, metadata = {}, title = null) {
    const resolvedTitle = title || `${i18n.$t('Section')} ${displayOrder}`;
    const model = this._getLayoutModel({}, resolvedTitle, pageId, displayOrder, metadata);
    return LayoutResource.addNewLayout(model);
  }

  /**
   *
   * @param sectionTemplate {SectionTemplate}
   * @param title {String}
   * @param pageId
   * @param displayOrder {Number}
   * @returns {Promise<*|void>}
   */
  async useTemplateAsLayout(sectionTemplate, title, pageId, displayOrder) {
    const sectionTitle = title || `${i18n.$t('Section')} ${displayOrder}`;
    const model = this._getLayoutModel(
      deepClone(sectionTemplate),
      sectionTitle,
      pageId,
      displayOrder
    );
    return SectionTemplateResource.useTemplateAsLayout(model);
  }

  /**
   *
   * @param id
   * @returns {Promise<any>}
   */
  deleteItem(id) {
    return LayoutResource.deleteItem(id);
  }

  /**
   * To increment download count of template.
   * @param layoutId
   * @returns {*}
   */
  incrementDownloadCount(layoutId) {
    return SectionTemplateResource.incrementDownloadCount(layoutId);
  }

  saveDrawOptions(id, drawOptions) {
    return LayoutResource.saveDrawOptions(id, drawOptions);
  }

  /**
   *
   * @param sectionTemplate {SectionTemplate}
   * @param title {String}
   * @param pageId
   * @param displayOrder {Number}
   * @param metadata {Object}
   * @returns {Layout}
   * @private
   */
  _getLayoutModel(sectionTemplate, title, pageId, displayOrder, metadata = {}) {
    const layout = {
      ...sectionTemplate,
      ...{
        id: sectionTemplate.id || null,
        page_id: pageId,
        title,
        widgets: {},
        display_order: displayOrder,
        is_in_library: false,
        is_predefined: false,
      },
      ...metadata,
    };
    return new Layout(layout);
  }
}

export default new LayoutService();
